<dx-drawer
  [openedStateMode]="'overlap'"
  [revealMode]="'slide'"
  class='drawer'
  [position]='"after"'
  [template]='"template"'
  [(opened)]='drawerOpened'
  [closeOnOutsideClick]='true'>
  <div *dxTemplate="let data of 'template'"
       style='width: 800px; height: -webkit-fill-available; height: fill-available;'>
    <div class='drawer-card'>
      <div class='container'>
        <app-drawer-order [orderId]='orderId' [abnormalLabel]='abnormalLabel'
                          [closeEvent]='closeDrawer'></app-drawer-order>
      </div>
    </div>
  </div>
  <div id='content'>
    <dx-toolbar height='54' style='padding-left: 16px; padding-right: 16px;' *ngIf='!isPhoneOrTablet'>
      <dxi-item location='after'>
        <dx-button
          text='Acknowledge'
          [disabled]='ButtonsDisabled || acknowledgeOrderSelected || pendingOrderSelected'
          (click)='ack()'
        ></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button text='Email Results'
                   [disabled]='selectedItemsIds.length === 0 || fusionAuthService.Profile === undefined'
                   (onClick)="openEmailFax('email')"></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button text='Fax Results'
                   [disabled]='selectedItemsIds.length === 0 || fusionAuthService.Profile === undefined'
                   (onClick)="openEmailFax('fax')"></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button text='Update Bill To' [disabled]='selectedItemsIds.length === 0'
                   (onClick)='openUpdateBillTo()'></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button
          [disabled]='selectedItemsIds.length === 0'
          text='Print Results'
          (click)='printLabResults()'
        ></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button
          [disabled]='selectedItemsIds.length === 0'
          text='Print Order Log'
          (click)='printOrderLog()'
        ></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button
          [disabled]='selectedItemsIds.length === 0'
          text='Print Order Details'
          (click)='printOrderDetails()'
        ></dx-button>
      </dxi-item>
      <dxi-item location='after'>
        <dx-button
          icon='columnchooser'
          (click)='showColumnChooser()'
        ></dx-button>
      </dxi-item>
    </dx-toolbar>

    <dx-data-grid
      [dataSource]='dataSource.value'
      [showRowLines]='true'
      [showBorders]='true'
      [highlightChanges]='true'
      [allowColumnReordering]='true'
      [repaintChangesOnly]='true'
      [hoverStateEnabled]='true'
      height='60vh'
      style='min-width: 250px !important;'
      [allowColumnResizing]='true'
      [columnAutoWidth]='true'
      [wordWrapEnabled]='true'
      [filterSyncEnabled]='true'


      (selectedRowKeysChange)='itemsSelected($event)'
      (onContentReady)='onContentReady()'
      [columnHidingEnabled]='isPhoneOrTablet'>
      <dxo-scrolling mode='multiple'></dxo-scrolling>
      <dxo-pager
        [visible]='true'
        [allowedPageSizes]='[10, 20, 50, 100]'
        [showInfo]='true'
        [showNavigationButtons]='true'
        [showPageSizeSelector]='true'
      ></dxo-pager>
      <dxo-filter-row [showOperationChooser]='true' [visible]='true'></dxo-filter-row>
      <dxo-filter-panel [visible]='true'></dxo-filter-panel>
      <dxo-selection mode='multiple' showCheckBoxesMode='always' selectAllMode='page'></dxo-selection>
      <dxo-sorting mode='multiple'></dxo-sorting>
      <dxo-remote-operations [filtering]='true' [sorting]='true' [paging]='true'></dxo-remote-operations>
      <dxo-header-filter [visible]='true'></dxo-header-filter>

      <dxi-column dataField='id' [visible]='false' [showInColumnChooser]='true' dataType='number' sortIndex='1'
                  sortOrder='desc'></dxi-column>
      <dxi-column dataField='hasMissingInfo' [visible]='false' [showInColumnChooser]='false'
                  dataType='boolean'></dxi-column>
      <dxi-column dataField='criticalMicResults' [visible]='false' [showInColumnChooser]='false'
                  dataType='boolean'></dxi-column>
      <dxi-column dataField='criticalResults' [visible]='false' [showInColumnChooser]='false'
                  dataType='boolean'></dxi-column>
      <dxi-column dataField='criticalToxResults' [visible]='false' [showInColumnChooser]='false'
                  dataType='boolean'></dxi-column>
      <dxi-column dataField='codeValue' caption='Order Number' [minWidth]='80' [allowHeaderFiltering]='false'
                  dataType='string'></dxi-column>
      <dxi-column caption='Order Date' dataField='orderDate' dataType='date' [allowHeaderFiltering]='false'
                  [selectedFilterOperation]='"between"'></dxi-column>
      <dxi-column caption='Collection Date' dataField='orderCollectionDate' [allowHeaderFiltering]='false'
                  dataType='datetime' [selectedFilterOperation]='"between"'></dxi-column>
      <dxi-column cssClass='wrappedColumnClass' caption='Last name' dataField='patientLastName'
                  [allowHeaderFiltering]='true' [minWidth]='60' [headerFilter]='lastNameHeaderFilter'></dxi-column>
      <dxi-column cssClass='wrappedColumnClass' caption='First name' dataField='patientFirstName'
                  [allowHeaderFiltering]='true' [minWidth]='60' [headerFilter]='firstNameHeaderFilter'></dxi-column>
      <dxi-column caption='Birthdate' dataField='patientDoB' dataType='date' [selectedFilterOperation]='"between"'
                  [allowHeaderFiltering]='false'></dxi-column>
      <dxi-column dataField='client' [allowFiltering]='true' dataType='string'
                  [allowHeaderFiltering]="userRoleInArray(['Client Basic', 'Client Admin', 'Superuser'])"
                  [headerFilter]='clientHeaderFilter'></dxi-column>
      <dxi-column caption='Unit' dataField='unit' dataType='string' [allowHeaderFiltering]='false'
                  [selectedFilterOperation]="'contains'" [showInColumnChooser]='true' [visible]='false'></dxi-column>
      <dxi-column caption='Room' dataField='patientRoom' dataType='string' [allowHeaderFiltering]='false'
                  [showInColumnChooser]='true' [visible]='false'></dxi-column>
      <dxi-column caption='Bed' dataField='patientBed' dataType='string' [allowHeaderFiltering]='false'
                  [showInColumnChooser]='true' [visible]='false'></dxi-column>
      <dxi-column caption='Tests' dataField='testNames' [allowFiltering]='true' dataType='string'
                  [allowHeaderFiltering]="userRoleInArray(['Client Basic', 'Client Admin', 'Superuser'])"
                  [headerFilter]='testsHeaderFilter'>
      </dxi-column>
      <dxi-column [visible]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 1'
                  *ngIf='webResultSettings !== undefined && webResultSettings.length >= 1'
                  headerCellTemplate='firstTestHeaderTemplate' caption='First Test' cellTemplate='firstTestTemplate'
                  [showInColumnChooser]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 1'></dxi-column>
      <dxi-column [visible]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 2'
                  *ngIf='webResultSettings !== undefined && webResultSettings.length >= 2'
                  headerCellTemplate='secondTestHeaderTemplate' caption='Second Test' cellTemplate='secondTestTemplate'
                  [showInColumnChooser]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 2'></dxi-column>
      <dxi-column [visible]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 3'
                  *ngIf='webResultSettings !== undefined && webResultSettings.length >= 3'
                  headerCellTemplate='thirdTestHeaderTemplate' caption='Third Test' cellTemplate='thirdTestTemplate'
                  [showInColumnChooser]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 3'></dxi-column>
      <dxi-column [visible]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 4'
                  *ngIf='webResultSettings !== undefined && webResultSettings.length >= 4'
                  headerCellTemplate='fourthTestHeaderTemplate' caption='Fourth Test' cellTemplate='fourthTestTemplate'
                  [showInColumnChooser]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length >= 4'></dxi-column>
      <dxi-column [visible]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length === 5'
                  *ngIf='webResultSettings !== undefined && webResultSettings.length >= 5'
                  headerCellTemplate='fifthTestHeaderTemplate' caption='Fifth Test' cellTemplate='fifthTestTemplate'
                  [showInColumnChooser]='!isPhoneOrTablet && webResultSettings !== undefined && webResultSettings.length === 5'></dxi-column>
      <div *dxTemplate="let title of 'firstTestHeaderTemplate'">
        {{ webResultSettings[0].testName }}
      </div>

      <div *dxTemplate="let order of 'firstTestTemplate'">
        {{ testResult(webResultSettings[0].testId, order.data)}}
      </div>

      <div *dxTemplate="let title of 'secondTestHeaderTemplate'">
        {{ webResultSettings[1].testName }}
      </div>

      <div *dxTemplate="let order of 'secondTestTemplate'">
        {{ testResult(webResultSettings[1].testId, order.data)}}
      </div>

      <div *dxTemplate="let title of 'thirdTestHeaderTemplate'">
        {{ webResultSettings[2].testName }}
      </div>

      <div *dxTemplate="let order of 'thirdTestTemplate'">
        {{ testResult(webResultSettings[2].testId, order.data)}}
      </div>

      <div *dxTemplate="let title of 'fourthTestHeaderTemplate'">
        {{ webResultSettings[3].testName }}
      </div>

      <div *dxTemplate="let order of 'fourthTestTemplate'">
        {{ testResult(webResultSettings[3].testId, order.data)}}
      </div>

      <div *dxTemplate="let title of 'fifthTestHeaderTemplate'">
        {{ webResultSettings[4].testName }}
      </div>

      <div *dxTemplate="let order of 'fifthTestTemplate'">
        {{ testResult(webResultSettings[4].testId, order.data) }}
      </div>

      <dxi-column caption='Ack' dataField='onlineAckUser' dataType='string' [selectedFilterOperation]='"contains"'
                  cellTemplate='ackTemplate' cssClass='align-vertical-cell' alignment='center' width='70'>
        <dxo-header-filter [dataSource]='ackHeaderFilter'></dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let order of 'ackTemplate'">
        <dx-tooltip target='#icon-{{ order.data.id }}' showEvent='dxhoverstart' hideEvent='dxhoverend'>
          <div *dxTemplate="let data of 'content'">
            <p><strong>User: </strong>{{ order.data.onlineAckUser }}</p>
            <p><strong>Date: </strong>{{ formatDate(order.data.onlineAckDateTime) }}</p>
          </div>
        </dx-tooltip>
        <i *ngIf='order.data.onlineAckUser' id='icon-{{ order.data.id }}' class='dx-icon-check'></i>
      </div>

      <dxi-column dataField='hasAlert' caption='Alerts' cellTemplate='alertCellTemplate' cssClass='align-vertical-cell'
                  [allowFiltering]='false' [allowHeaderFiltering]='true'>
        <dxo-header-filter [dataSource]='criticalResultHeaderFilter'></dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let order of 'alertCellTemplate'">
        <div fxLayout='row' fxLayoutAlign='center center' [innerHTML]='getCriticalResultStatus(order.data)'></div>
      </div>

      <dxi-column dataField='status' dataType='string' [allowFiltering]='false' [allowHeaderFiltering]='true'
                  caption='Status' cellTemplate='statusCellTemplate' cssClass='align-vertical-cell'>
        <dxo-header-filter [dataSource]='statusHeaderFilter'></dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let order of 'statusCellTemplate'">
        <div fxLayout='row' fxLayoutAlign='center center' [innerHTML]='getStatus(order.data)'></div>
      </div>

      <dxi-column cellTemplate='editCellTemplate' [allowHeaderFiltering]='true' cssClass='align-vertical-cell'>
        <dxo-header-filter [dataSource]='editHeaderFilter'></dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let order of 'editCellTemplate'">
        <dx-button *ngIf='order.data.hasMissingInfo && showMissingInfo' (click)='openMissingInfo(order)' icon='warning'
                   hint='Missing Information'></dx-button>
        <dx-button (onClick)='openPreview(order.data.id)' icon='fas fa-eye' hint='Preview'></dx-button>
      </div>
    </dx-data-grid>

    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='message'
      label='Email Results'
      [index]='1'
      (onClick)="openEmailFax('email')">
    </dx-speed-dial-action>
    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='message'
      label='Fax Results'
      [index]='2'
      (onClick)="openEmailFax('fax')">
    </dx-speed-dial-action>
    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='print'
      label='Print Results'
      [index]='3'
      (onClick)='printLabResults()'>
    </dx-speed-dial-action>
    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='export'
      label='Print Orders Log'
      [index]='4'
      (onClick)='printOrderLog()'>
    </dx-speed-dial-action>
    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='export'
      label='Print Order Details'
      [index]='4'
      (onClick)='printOrderDetails()'>
    </dx-speed-dial-action>
    <dx-speed-dial-action
      *ngIf='FABDisabled'
      icon='check'
      label='Acknowledge'
      [index]='5'
      (onClick)='ack()'>
    </dx-speed-dial-action>

    <app-missing-info
      [popupVisible]='missingInfoPopupVisible'
      [order]='missingInfoData'
      (closeEvent)='closeMissingInfo($event)'
    ></app-missing-info>

    <app-email-fax-dialog
      [popupVisible]='emailFaxVisible'
      [type]='type'
      [ids]='selectedItemsIds'
      [from]="'order'"
      (closeEvent)='emailFaxVisible = false'>
    </app-email-fax-dialog>

    <app-update-bill-to
      [popupVisible]='updateBillToVisible'
      [ids]='selectedItemsIds'
      [from]="'order'"
      (closeEvent)='closeUpdateBillTo()'>
    </app-update-bill-to>

    <dx-load-panel
      shadingColor='rgba(0,0,0,0.4)'
      [(visible)]='isLoading'
      [showIndicator]='true'
      [showPane]='true'
      [shading]='true'
      [closeOnOutsideClick]='false'>
    </dx-load-panel>
  </div>
</dx-drawer>
